var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"athlete-wrapper"},[_c('div',{staticClass:"athlete-header"},[_c('span',{staticStyle:{"width":"20%"}},[_vm._v("姓名")]),_c('span',{staticStyle:{"flex":"1"}},[_vm._v("身份证号")]),_c('span',{staticStyle:{"width":"30%"}},[_vm._v("发证日期")])]),_c('div',{staticClass:"swiper athlete-wheel"},[_c('div',{staticClass:"swiper-wrapper"})])])
}]

export { render, staticRenderFns }